import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	sbIconButton: {
		marginRight: "4px",
		size: 20,
	},
}));
